import React, { useState, useEffect  } from 'react'
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import {
  Container,
  Row,
  Col,
  Input,
} from 'reactstrap';
import * as MyAPI from '../../../utils/MyAPI'
import Header from '../parts/Header'
import Footer from '../parts/Footer'
import ApiSubHeader from '../parts/ApiSubHeader'
import Alert from 'react-s-alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AspIdItem from './AspIdItem'
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';


// ApiAspIdManager
const ApiAspIdManager = (props) => {

  let navigate = useNavigate();
  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  });
  let subscription_status = useSelector(state => {
    if (state.user && state.user.subscription_status) {
      return state.user.subscription_status
    } else {
      return 'unknown'
    }
  });

  let [loading, setLoading] = useState(false)
  let [kanjiInput, setKanjiInput] = useState("")
  let [kanaInput, setKanaInput] = useState("")
  let [typeInput, setTypeInput] = useState("")
  let [deepSpeechTokens, setDeepSpeechTokens] = useState([]);
  let [apiIdSelected, setApiIdSelected] = useState("")
  let [vocabList, setVocabList] = useState([])
  let [skip, setSkip] = useState(0)
  let [totalVocabCount, setTotalVocabCount] = useState(0)
  let [shareableDictionarySuggestions, setShareableDictionarySuggestions] = useState([])

  // componentDidMount
  useEffect(() => {

    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let _firstScript = () => {

    if (!login_token) {
      // redirect
      navigate("/dashboard")
      return
    }

    if (subscription_status !== "active") {
      navigate("/api_manager_top")
      return
    }

    _getDeepSpeechTokens()

    _getSharableDictionaryList()

  }

  // get api tokens
  let _getDeepSpeechTokens = async () => {


    setLoading(true)

    try {
      // logout on server
      let _results = await MyAPI.getDeepSpeechTokens({
        login_token: login_token,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }


      // name to display
      let _list1 = _results.list1
      for ( let i=0; i<_list1.length; i++ ) {
        let _item = _list1[i]
        let _api_key = _item.api_key
        let _memo = _item.memo
        //let _disp = _item.api_key.substr(0, 16)+"…"
        // if ( _item.memo ) {
        //   if (_item.memo.length < 17) {
        //     _disp = _item.memo
        //   } else {
        //     _disp = _item.memo.substr(0, 16)+"…"
        //   }

        // }
        _list1[i].disp_name = _api_key + "(" + _memo + ")"
      }

      setDeepSpeechTokens(_list1)

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }

    setLoading(false)
  }



  // get asp id list
  let _getVocabList = async ({
    ai_api_id,
    skip2,
  }) => {

    setLoading(true)

    try {

      if (!ai_api_id) {
        throw Error("no api is selected")
      }

      // logout on server
      // let _results = await MyAPI.getVocabList({
      let _results = await MyAPI.getAspIdList({
        login_token: login_token,
        ai_api_id: ai_api_id,
        skip: skip2,
        // search_text: searchText,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }
      console.log("_results.list1: ", _results)

      if ( _results.list1 ) {
        setVocabList(_results.list1)
      } else {
        setVocabList([])
      }

      if (_results.count1) {
        setTotalVocabCount(_results.count1)
      } else {
        setTotalVocabCount(0)
      }

    } catch (err) {
      console.log("err: ", err)
    }

    setLoading(false)
  }

 

  // api selected changed
  let _apiIdSelectedChanged = (e) => {

    setApiIdSelected(e.target.value)

    _getVocabList({
      ai_api_id: e.target.value,
      skip2: skip,
    })
  }


  // update asp item 
  let _updateAspItem = async (item, dictTags) => {

    setLoading(true)

    try {

      console.log("dictTags: ", dictTags)

      // get evaluation masters
      const results_1 = await MyAPI.updateAspItem({
        login_token: login_token,
        asp_id: item.asp_id,
        dict_items: dictTags,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      // get vocabs
      _getVocabList({
        ai_api_id: apiIdSelected,
        skip2: 0,
      })

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }
    setLoading(false)
  }


  // go next 100
  let _goNext = () => {

    let _skip = skip
    _skip = _skip + 100

    if (_skip > totalVocabCount) {
      _skip = totalVocabCount
    }

    setSkip(_skip)

    // get vocabs
    _getVocabList({
      ai_api_id: apiIdSelected,
      skip2: _skip,
    })
  }

  // go back
  let _goBack = () => {
    let _skip = skip
    _skip = _skip - 100
    if (_skip < 0) {
      _skip = 0
    }
    setSkip(_skip)

    // get vocabs
    _getVocabList({
      ai_api_id: apiIdSelected,
      skip2: _skip,
    })
  }

  // set loader
  let _setLoading = (arg) => {
    setLoading(arg)
  }



  // _getSharableDictionaryList
  let _getSharableDictionaryList = async () => {

    setLoading(true)

    try {
      // logout on server
      let _results = await MyAPI.getSharableDictionaryList({
        login_token: login_token,
        include_public: true,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }
      // console.log("getSharableDictionaryList._results: ", _results)

      let _suggestions = []
      if (_results && _results.list1) {
        for (let i=0; i<_results.list1.length; i++) {

          let _item = _results.list1[i]

          let _exists = false
          for (let j=0; j<_suggestions.length; j++) {
            if (_suggestions[j].id === _item._id) {
              _exists = true
              break
            }
          }

          if (_exists === false) {
            _suggestions.push({
              id: _item._id,
              name: _item.dictionary_name,
            })
          }
        }
      }

      console.log("_suggestions: ", _suggestions)

      setShareableDictionarySuggestions(_suggestions)

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }
    setLoading(false)
  }


  return (
    <div>

      <Header />

      <ApiSubHeader />

      {/* main */}
      <Container style={{
        marginTop: 40,
        minHeight: 300,
      }}>

        <Row style={{
          marginTop: 20,
          marginBottom: 20,
        }}>

          <Col md="12" xs="12" style={{
            textAlign: 'left',
          }}>

            <span onClick={_getDeepSpeechTokens} style={{
              cursor: 'pointer',
              marginRight: 10,
            }}>
              APIキーを選択してください
            </span>

          </Col>

        </Row>

        <Row style={{
          // backgroundColor: '#cccccc',
          marginTop: 5,
          marginBottom: 40,
        }}>

          <Col md="6" xs="12" style={{
            textAlign: 'left',
          }}>
            <Input onChange={_apiIdSelectedChanged}
              type="select"
              name="apiIdSelected"
              value={apiIdSelected}>

              <option
                key={"dummy_api_key_id"}
                value={""}>
                  選択してください
              </option>

              {deepSpeechTokens.map((item) => (
                <option
                  key={item._id}
                  value={item._id}>
                    {item.disp_name}
                </option>
              ))}
            </Input>
          </Col>
          <Col md="6" xs="12" style={{
            textAlign: 'right',
            fontSize: 18,
          }}>
          </Col>

        </Row>

        {/* default mode */}
        {apiIdSelected && (
          <div>

            {/* controller */}
            <Row style={{
              backgroundColor: '#ffffff',
              marginTop: 10,
              marginBottom: 10,
            }}>
              <Col md="6" xs="12">
              </Col>

              <Col md="6" xs="12" style={{
                textAlign: 'right',
              }}>

                {skip !== 0 ? (
                  <FontAwesomeIcon
                    onClick={_goBack}
                    icon="arrow-left"
                    style={{
                      cursor: 'pointer',
                      marginRight: 10,
                  }}/>
                ) : (
                  <FontAwesomeIcon
                    icon="arrow-left"
                    style={{
                      color: '#cccccc',
                      marginRight: 10,
                  }}/>
                )}

                {skip+100 > totalVocabCount ? (
                  <FontAwesomeIcon
                    icon="arrow-right"
                    style={{
                      marginLeft: 10,
                      color: '#cccccc',
                  }}/>
                ) : (
                  <FontAwesomeIcon
                    onClick={_goNext}
                    icon="arrow-right"
                    style={{
                      marginLeft: 10,
                      cursor: 'pointer',
                  }}/>
                )}

              </Col>
            </Row>


            <Row style={{
              backgroundColor: '#555555',
              color: '#ffffff',
              marginTop: 10,
              marginBottom: 10,
              marginLeft: 0,
              marginRight: 0,
            }}>

              <Col md="3" xs="12" style={{
                textAlign: 'left',
              }}>
                <span>
                  ASP ID
                </span>
              </Col>
              <Col md="3" xs="12" style={{
                textAlign: 'left',
              }}>
                <span>
                  ASP NAME
                </span>
              </Col>
              <Col md="5" xs="12" style={{
                textAlign: 'left',
              }}>
                <span>
                  辞書利用
                </span>
              </Col>
              <Col md="1" xs="12" style={{
                textAlign: 'left',
              }}>
                
              </Col>

            </Row>

            {/* vocab add */}
            {/*<Row style={{
              // backgroundColor: '#cccccc',
              marginTop: 10,
              marginBottom: 10,
            }}>

              <Col md="2" xs="12" style={{
                textAlign: 'left',
              }}>

                <Input
                  type="text"
                  style={{
                    width: '100%',
                  }}
                  name='kanjiInput'
                  onChange={_kanjiInputChanged}
                  value={kanjiInput} />

              </Col>
              <Col md="2" xs="12" style={{
                textAlign: 'left',
              }}>
                <Input
                  type="text"
                  style={{
                    width: '100%',
                  }}
                  name='kanaInput'
                  onChange={_kanaInputChanged}
                  value={kanaInput} />
              </Col>
              <Col md="2" xs="12" style={{
                textAlign: 'left',
              }}>
                
           
                <FontAwesomeIcon
                  onClick={() => setUseAsDict(!useAsDict)}
                  icon={useAsDict === true ? 'toggle-on' : 'toggle-off'}
                  style={{
                    cursor: 'pointer',
                    marginLeft: 6,
                }}/>
              </Col>

              <Col md="2" xs="12" style={{
                textAlign: 'left',
              }}>

                <Input
                  type="text"
                  style={{
                    width: '100%',
                  }}
                  name='categoryText'
                  onChange={(e) => setCategoryText(e.target.value)}
                  value={categoryText} /> 
               
              </Col>


              <Col md="2" xs="12" style={{
                textAlign: 'left',
              }}>

                <Input
                  type="text"
                  style={{
                    width: '100%',
                  }}
                  name='colorText'
                  onChange={(e) => setColorText(e.target.value)}
                  value={colorText} /> 
               
              </Col>

              <Col md="2" xs="12" style={{
                textAlign: 'left',
              }}>
                <Button onClick={_addVocab2Dict} color="primary">
                  追加
                </Button>
              </Col>

            </Row>*/}


            {/* vocab list */}
            {vocabList.map((item, idx) => (

              <>
               <AspIdItem
                idx={idx}
                key={item._id}
                item={item}
                shareableDictionarySuggestions={shareableDictionarySuggestions}
                updateAspItem={_updateAspItem} /> 
              </>

            ))}

          </div>
        )}

      </Container>

      <br/>

      {/* footer */}
      <Footer />

      {/* loading */}
      <Loader fullPage={true} loading={loading} />

    </div>
  )
}

export default ApiAspIdManager
